import React, {FC, ReactNode} from 'react';
import {styled} from 'styled-components';

import {EventHandler} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {StyledNavigationLabelDiv, StyledNavigationTextDiv} from './navigationHelpers';
import {NavigationLine} from './navigationLine';
import {NavigationLineLabel} from './navigationLineLabel';
import {NavigationLineStandardIcon} from './navigationLineStandardIcon';

/*
 * Props.
 */

interface NavigationItemProps {
  iconName: IconName;
  selectedIconName: IconName;
  children: ReactNode;
  isSelected?: boolean;
  onClick?: EventHandler;
}

/*
 * Style.
 */

const StyledNavigationItemTextDiv = styled(StyledNavigationTextDiv)`
  display: flex;
  align-items: center;
`;

/*
 * Component.
 */

export const NavigationItem: FC<NavigationItemProps> = (props) => {
  const {iconName, selectedIconName, children, isSelected, onClick} = props;
  return (
    <NavigationLine indentLevel={0} isSelected={isSelected} onClick={onClick}>
      <NavigationLineStandardIcon iconName={isSelected ? selectedIconName : iconName} />
      <NavigationLineLabel>
        <StyledNavigationLabelDiv>
          <StyledNavigationItemTextDiv>{children}</StyledNavigationItemTextDiv>
        </StyledNavigationLabelDiv>
      </NavigationLineLabel>
    </NavigationLine>
  );
};
